module.exports = __webpack_public_path__ + "static/media/24.566c7347.wav";